import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const SwiperMuteIcon = (props) => (
  <SVGUniqueID>
    <svg
      width={20}
      height={20}
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className="clr-i-outline clr-i-outline-path-1"
        d="M3.61 6.41 9.19 12H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5.14l7.41 7.47A2 2 0 0 0 18 32a2 2 0 0 0 .76-.15A2 2 0 0 0 20 30v-7.23l5.89 5.89c-.25.15-.49.29-.75.42a1 1 0 0 0 .9 1.79 14 14 0 0 0 1.31-.75l2.28 2.28L31 31 5 5ZM18 30l-7.73-7.77a1 1 0 0 0-.71-.23H4v-8h5.64a1 1 0 0 0 .71-.3l.26-.26L18 20.81Z"
      />
      <path
        className="clr-i-outline clr-i-outline-path-2"
        d="M24.89 6.69A12.42 12.42 0 0 1 29 26.1l1.42 1.42a14.42 14.42 0 0 0-4.66-22.64 1 1 0 1 0-.87 1.8Z"
      />
      <path
        className="clr-i-outline clr-i-outline-path-3"
        d="M22.69 12.62A6.27 6.27 0 0 1 25.8 18a6.17 6.17 0 0 1-1.24 3.71L26 23.13A8.15 8.15 0 0 0 27.8 18a8.28 8.28 0 0 0-4.1-7.11 1 1 0 1 0-1 1.73Z"
      />
      <path
        className="clr-i-outline clr-i-outline-path-4"
        d="M18 6v9.15l2 2V6a2 2 0 0 0-3.42-1.41L12 9.17l1.41 1.41Z"
      />
      <path fill="none" d="M0 0h36v36H0z" />
    </svg>
  </SVGUniqueID>
);
export { SwiperMuteIcon };
